module.exports = __webpack_public_path__ + "img/stepOne.2fab046d.png";